export const COLOR_TOOL_BRAND = {
  nl: 'colora',
  fr: 'coloraF',
};
